import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithActionButtons } from '../../../../components/designe/app-bars/app-bar-with-buttons/AppBarWithActionButtons';
import ViewField from '../../../../components/reusable/view-field/ViewField';
import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { useThemeContext } from '../../../../context/ThemeContext';
import { Paths } from '../../../../shared/paths';
import { PRIMARY_COLOR_MAP } from '../../../../shared/primary-color-map';
import { useStyles } from './UserConfigView.styles';
import { useUserConfigViewComponent } from './useUserConfigViewComponent';

export default function UserConfigView(props) {
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { user, language } = useUserConfigViewComponent();
  const { replace } = useNavigationStack();
  const { theme: themeMode, primaryColor } = useThemeContext();
  const colorValues = PRIMARY_COLOR_MAP[primaryColor];

  return (
    <div className={classes.userConfigWrapper}>
      <Box className={classes.userConfigContent}>
        <Box display="flex" alignItems="center" gap={1}>
          <ViewField
            label={t('settings.visualization.primaryColor')}
            value={t(`settings.visualization.primaryColor_${primaryColor}`)}
            noShadow
            className={classes.viewItem}
          />
          <Box
            className={classes.colorPreview}
            sx={{ backgroundColor: colorValues?.main }}
          />
        </Box>
        <Box>
          <ViewField
            label={t('settings.visualization.theme')}
            value={t(`settings.visualization.theme_${themeMode}`)}
            noShadow
            className={classes.viewItem}
          />
        </Box>
        <Box>
          <ViewField
            label={t('common.language')}
            value={language?.title}
            noShadow
            className={classes.viewItem}
          />
        </Box>
        <Box>
          <ViewField
            label={t('settings.pagePrivacy')}
            value={t(`settings.pagePrivacy_${user?.accessConfig?.scope}`)}
            noShadow
            className={classes.viewItem}
          />
        </Box>

        <Box>
          <ViewField
            label={t('settings.whoCanAddPost')}
            value={t(`settings.postPrivacy_${user?.accessConfig?.postsScope}`)}
            noShadow
            className={classes.viewItem}
          />
        </Box>
        <Box>
          <ViewField
            label={t('settings.whoCanComment')}
            value={t(
              `settings.commentPrivacy_${user?.accessConfig?.commentsScope}`,
            )}
            noShadow
            className={classes.viewItem}
          />
        </Box>
        <Box className={classes.buttonWrapper}>
          <AppBarWithActionButtons
            onEditClick={() => replace(Paths.settings.toConfigEdit)}
          />
        </Box>
      </Box>
    </div>
  );
}
